<div class="p-grid" id="mu-auth-account-data">
  <h2 class="mu-layout-auth-sub-title p-col-12" innerHTML="{{ 'context.accountData.step' | translate: { step: 1 } }}"></h2>
  <h1 class="mu-layout-auth-title p-col-12" innerHTML="{{ 'context.accountData.titleData' | translate }}"></h1>
  <div class="p-col-12 mu-without-padding">
    <app-auth-account-data-form
      [country]="country"
      [loader]="flagList.get(accountDataFlags.CHECK_EMAIL)"
      [formData]="formData"
      [passwordCheckerField]="authConstants.passwordCheckerField"
      [passwordCheckerName]="authConstants.passwordCheckerName"
      [passwordCheckerParams]="authConstants.passwordCheckerParams"
      [actionList]="actionList"
      [nextStepAction]="accountDataActionsEnum.NEXT_STEP"
      [termsLink]="termsLink"
      [politicsLink]="politicsLink"
    ></app-auth-account-data-form>
  </div>
</div>
